// extracted by mini-css-extract-plugin
export default {"checkout-wrapper":"checkout-wrapper--FZj3U","checkoutWrapper":"checkout-wrapper--FZj3U"};